import React from 'react';
import { connect } from 'react-redux';
import LargeQuote from './LargeQuote.jsx';


class LargeQuoteCard extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'LargeQuoteCard';

    // bind functions to component
    this.renderDescription = this.renderDescription.bind(this);
    this.renderQuotes = this.renderQuotes.bind(this);
  }


  /**
   * Renders quotes description
   * @returns {ReactElement} - A ReactElement
   */
  renderDescription() {
    const data = this.props.data;
    let element;

    if (data.description) {
      element = (
        <div className='description'>{data.description}</div>
      );
    }

    return element;
  }


  /**
   * Renders component
   * @returns {Array<ReactElement>} - An array of ReactElements
   */
  renderQuotes() {
    const data = this.props.data;
    const quotes = [];

    for (let i = 0; i < data.quotes.length; i++) {
      quotes.push(
        <LargeQuote
          key={'quote-' + data.order + '-' + i}
          data={data.quotes[i]}
        />
      );
    }

    return quotes;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const description = this.renderDescription();
    const quotes = this.renderQuotes();
    const data = this.props.data;
    const state = this.props.smallCardFrameworkState;
    const activeClass = (state.currentCardIteration + 1 === data.order) ?
      ' active' : '';
    const gridClass = ' large-top-push-' + data.largeTopPush +
      ' large-col-' + data.largeGridColumns +
      ' large-push-' + data.largeGridPush;
    const className = 'card component-large-quote-card' + activeClass +
      gridClass;

    return (
      <section
        className={className}
        style={this.props.style}
      >
        {description}
        {quotes}
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Number} iteration - The iteration of the component
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 * @prop {Object} style - A style object
 */
LargeQuoteCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  iteration: React.PropTypes.number.isRequired,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, smallCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, smallCardFrameworkState }))(LargeQuoteCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/large/LargeQuoteCard.jsx
 **/